var map = {
	"./background.svg": "0581",
	"./barcode.png": "48b6",
	"./contact.png": "dfe7",
	"./goldpostlogo.png": "aa41",
	"./hoplucpostlogo.png": "15b2",
	"./logo-ant.svg": "b1e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";